<template>
  <v-row style="height: 100%;">
    <v-col>
      <transition name="fade-up" mode="out-in" appear>
        <dashboard-index />
      </transition>
    </v-col>
  </v-row>
</template>

<script>
import DashboardIndex from '@/views/dashboard/Index'
export default {
  name: 'Dashboard',
  components: {
    DashboardIndex
  },
  data: () => ({

  }),
  methods: {

  }
}
</script>